import React from "react";
import {
  Card,
  Box,
  Typography,
  Button,
  IconButton,
  styled,
  Dialog,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EggImage from "../static/img/egg.png"; // replace with your egg image

// Styled Dialog
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    backgroundColor: "#FFE8BC",
    borderRadius: 16,
    padding: theme.spacing(2),
    minWidth: 300,
    minHeight: 380,
    border: "2px solid black",
    overflow: "visible",
    position: "relative",
  },
}));

// Header pill button
const HeaderButton = styled(Box)(() => ({
  backgroundColor: "#FFA800",
  color: "black",
  padding: ".5em 1.2em",
  borderRadius: 50,
  fontWeight: 600,
  border: "2px solid black",
  position: "absolute",
  top: "-20px",
  left: "50%",
  transform: "translateX(-50%)",
  textAlign: "center",
  maxWidth: 230,
}));

// CTA button
const SubmitButton = styled(Button)(() => ({
  backgroundColor: "#FAAE1C",
  color: "black",
  borderRadius: 16,
  padding: "8px",
  fontSize: "18px",
  fontWeight: "bold",
  width: "70%",
  "&:hover": {
    backgroundColor: "#FF8C00",
  },
  position: "absolute",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  textTransform: "none",
}));

const EggGiftCard = ({ open, onClose }) => {
  // ✅ Smooth scroll to Game Guides section
  const handleGetStarted = () => {
    onClose(); // close popup first
    setTimeout(() => {
      const section = document.getElementById("game-guides-section");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 300);
  };

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      {/* Header + Close */}
      <HeaderButton>Win a Gift!</HeaderButton>
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: "-18px",
          right: "-18px",
          backgroundColor: "#FFE8BC",
          border: "2px solid black",
          color: "black",
          "&:hover": { backgroundColor: "#dbc69f" },
          width: 36,
          height: 36,
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      {/* Content */}
      <DialogContent sx={{ p: 0, mt: 4 }}>
        <Typography
          variant="body2"
          sx={{
            color: "#000",
            fontWeight: 500,
            maxWidth: "100%",
            mx: "auto",
            mb: 3,
            textAlign: "center",
            whiteSpace: "normal",
          }}
        >
          Click on easter eggs in videos and unlock the puzzles to win an
          exciting gift!
        </Typography>

        {/* Egg with Numbers */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "inline-block",
              "& img": {
                animation: "eggFloat 3s ease-in-out infinite",
                "@keyframes eggFloat": {
                  "0%": {
                    transform: "translateY(0px) rotate(0deg) scale(1)",
                    filter: "drop-shadow(0px 0px 0px rgba(255, 200, 50, 0))",
                  },
                  "25%": {
                    transform: "translateY(-4px) rotate(-3deg) scale(1.03)",
                    filter:
                      "drop-shadow(0px 0px 6px rgba(255, 200, 50, 0.4))",
                  },
                  "50%": {
                    transform: "translateY(-8px) rotate(3deg) scale(1.05)",
                    filter:
                      "drop-shadow(0px 0px 12px rgba(255, 200, 50, 0.7))",
                  },
                  "75%": {
                    transform: "translateY(-4px) rotate(-3deg) scale(1.03)",
                    filter:
                      "drop-shadow(0px 0px 6px rgba(255, 200, 50, 0.4))",
                  },
                  "100%": {
                    transform: "translateY(0px) rotate(0deg) scale(1)",
                    filter: "drop-shadow(0px 0px 0px rgba(255, 200, 50, 0))",
                  },
                },
              },
              "& .pulse": {
                animation: "pulseNumber 1.6s ease-in-out infinite",
                "@keyframes pulseNumber": {
                  "0%": { transform: "scale(1)", textShadow: "none" },
                  "50%": {
                    transform: "scale(1.15)",
                    textShadow:
                      "0px 0px 10px currentColor, 0px 0px 15px currentColor",
                  },
                  "100%": { transform: "scale(1)", textShadow: "none" },
                },
              },
            }}
          >
            <img src={EggImage} alt="Easter Egg" style={{ width: 140, height: 150 }} />
            <Typography className="pulse" sx={{ position: "absolute", top: "10%", right: "20%", color: "#8522A8", fontWeight: "bold", fontSize: "1.2rem" }}>1</Typography>
            <Typography className="pulse" sx={{ position: "absolute", top: "5%", left: "18%", color: "#FF5280", fontWeight: "bold", fontSize: "1.2rem" }}>4</Typography>
            <Typography className="pulse" sx={{ position: "absolute", top: "32%", left: "-8%", color: "#D83335", fontWeight: "bold", fontSize: "1.2rem" }}>3</Typography>
            <Typography className="pulse" sx={{ position: "absolute", top: "35%", right: "-8%", color: "#3F51B5", fontWeight: "bold", fontSize: "1.2rem" }}>6</Typography>
            <Typography className="pulse" sx={{ position: "absolute", bottom: "12%", right: "2%", color: "#D83335", fontWeight: "extrabold", fontSize: "1.5rem" }}>2</Typography>
            <Typography className="pulse" sx={{ position: "absolute", bottom: "18%", left: "2%", color: "#07A91C", fontWeight: "bold", fontSize: "1.2rem" }}>5</Typography>
          </Box>
        </Box>

        {/* CTA */}
        <SubmitButton variant="contained" onClick={handleGetStarted}>
          Get Started
        </SubmitButton>
      </DialogContent>
    </StyledDialog>
  );
};

export default EggGiftCard;
